module.exports = __webpack_public_path__ + "img/slack-integration.e06305d9.png";